import React, { useEffect, useState, useRef } from 'react';
import packageBox from './package-box.png';
import background from './bckgd.jpg';
import Button from '../common/Button';
import { MdHome, MdLogin } from 'react-icons/md';
import { Link } from 'react-router-dom';

const PublicHome: React.FC = () => {
  const [visibleProverbIndex, setVisibleProverbIndex] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  const proverbs = [
    "Slow is the turtle, though it will win the race.",
    "Doing everything is doing nothing. It's once you settle back that you will see the everything.",
    "Grab it, group it, list it."
  ];

  useEffect(() => {
    // Rotate proverbs every 5 seconds
    const proverbInterval = setInterval(() => {
      setVisibleProverbIndex((prev) => (prev + 1) % proverbs.length);
    }, 5000);

    return () => clearInterval(proverbInterval);
  }, [proverbs.length]);

  useEffect(() => {
    // Add falling icons
    const addIcon = () => {
      if (!contentRef.current) return;

      const img = document.createElement('img');
      img.src = packageBox;
      img.style.width = '60px';
      img.style.height = '60px';
      img.style.position = 'absolute';
      img.style.right = '-60px';
      img.style.transform = 'translateX(0)';
      img.style.animation = 'fall 15s linear forwards';

      const contentHeight = contentRef.current.clientHeight;
      const randomY = Math.floor(Math.random() * (contentHeight - 60));
      img.style.top = randomY + 'px';

      img.addEventListener('animationend', function() {
        if (contentRef.current && img.parentNode) {
          contentRef.current.removeChild(img);
        }
      });

      contentRef.current.appendChild(img);
    };

    const iconInterval = setInterval(addIcon, 200);
    setTimeout(addIcon, 200);

    return () => clearInterval(iconInterval);
  }, []);

  const isLoggedIn = localStorage.getItem('authToken');

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');
          @keyframes fall {
            to {
              transform: translateX(calc(-100vw - 60px));
            }
          }
        `}
      </style>
      
      <div 
        className="font-sans m-0 p-0 overflow-hidden flex flex-col items-stretch justify-start h-screen w-full"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="flex flex-row items-center bg-black text-white">
          <h1 className="font-['Permanent_Marker'] p-3.5 text-3xl m-0">
            Wide Like a River
          </h1>
          <div className="p-3.5 relative flex-1">
            {proverbs.map((proverb, index) => (
              <p
                key={index}
                className={`absolute top-1 left-0 text-xl leading-tight transition-opacity duration-500 ease-in-out ${
                  index === visibleProverbIndex ? 'opacity-100' : 'opacity-0'
                }`}
              >
                {proverb}
              </p>
            ))}
          </div>

          {!isLoggedIn && (
            <Link to="/login" className="mr-3">
              <Button preset='primary'>
                <MdLogin className="mr-2" />
                Login
              </Button>
            </Link>
          )}
          {isLoggedIn && (
            <Link to="/ads" className="mr-3">
              <Button preset='primary'>
                <MdHome className="mr-2" />
                You are logged. Access App
              </Button>
            </Link>
          )}
        </div>
        <div 
          id="content" 
          ref={contentRef}
          className="flex-1 relative"
        ></div>
      </div>
    </>
  );
};

export default PublicHome;
